import { render } from "./LiderStep.vue?vue&type=template&id=2b36d94a"
import script from "./LiderStep.vue?vue&type=script&lang=js"
export * from "./LiderStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__